import { useEffect } from 'react';
import Chart from 'react-apexcharts';

const PieChart = ({ labels, series, colors = null }) => {
    const options = {
        chart: {
            type: 'pie',
            locales: [
                {
                    name: "tr",
                    options: {
                        months: [
                            "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
                            "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
                        ],
                        shortMonths: [
                            "Oca", "Şub", "Mar", "Nis", "May", "Haz",
                            "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"
                        ],
                        days: [
                            "Pazar", "Pazartesi", "Salı", "Çarşamba", 
                            "Perşembe", "Cuma", "Cumartesi"
                        ],
                        shortDays: ["Pzr", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
                        toolbar: {
                            exportToSVG: "SVG İndir",
                            exportToPNG: "PNG İndir",
                            exportToCSV: "CSV İndir",
                            menu: "Menü",
                            selection: "Seçim",
                            selectionZoom: "Bölge Yakınlaştır",
                            zoomIn: "Yakınlaştır",
                            zoomOut: "Uzaklaştır",
                            pan: "Kaydır",
                            reset: "Sıfırla"
                        }
                    }
                }
            ],
            defaultLocale: "tr"
        },
        labels: labels,
        colors: colors ? colors : null,
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 300
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }
        ]
    };

    return (
        <Chart options={options} series={series} type="pie" width="500" />
    );
};

export default PieChart;